const ErrorBoundry = ()=>{
	return (
		<> 
		<div className="main-form-sec error-page">
			<h1 className="error">500</h1>
			<div className="page">Internal Error occurred please try to reload the page</div>
			<button className="btn-blue btn" type="button">Reload</button>
		</div>
		</>
	);
}
export default ErrorBoundry;